import { Flex, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const LOGO_SRC = "/images/cle-logo-nav.webp";

const Logo = () => {
  const navigate = useNavigate();

  return (
    <Flex
      alignItems="center"
      cursor="pointer"
      onClick={() => navigate("/")}
      role="button"
      tabIndex={0}
      aria-label="CLE, go to home"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate("/");
        }
      }}
    >
      <Image
        src={LOGO_SRC}
        alt="CLE — Community Learning Ecosystem"
        htmlHeight={106}
        htmlWidth={280}
        h={{ base: "44px", md: "52px" }}
        w="auto"
        maxW={{ base: "min(100vw - 8rem, 320px)", md: "380px" }}
        objectFit="contain"
        objectPosition="left center"
      />
    </Flex>
  );
};

export default Logo;
